import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

interface SignUpFormBackButtonProps {
  onBack: () => void;
}

export const SignUpFormBackButton = ({ onBack }: SignUpFormBackButtonProps) => (
  <Button
    type="button"
    variant="secondary"
    onClick={onBack}
    className="flex h-12 w-12 items-center justify-center rounded-full border !border-[#E1E6EA] p-0"
    aria-label={t("back")}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.75537 7.98682H13.25"
        stroke="#545861"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75674 4L2.75 8L6.75674 12"
        stroke="#545861"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Button>
);
